import React, { FC, ReactNode, useContext, useEffect, useState } from 'react'
import { Clear } from '@mui/icons-material'

import { HandleModalContext } from '../../../layout/mainlayout/MainLayout'

import { cn } from '../../../lib/utils'

import { MODAL_CONSTS } from '../../../const/modal-const'

const DURATION = 500

interface DrawerModalProps {
  children: ReactNode
  type: 'RIDER_INFO' | 'REGISTRAR_INFO'
  className?: string
  overlayClassName?: string
  onClose?: () => void
}

export const DrawerModal: FC<DrawerModalProps> = ({
  children,
  type,
  className,
  overlayClassName,
  onClose,
}) => {
  const handleModal = useContext(HandleModalContext)?.handleModal
  const [visible, setVisible] = useState(false)

  const closeModal = () => {
    if (!handleModal) return
    setVisible(false)
    setTimeout(() => handleModal?.(false, MODAL_CONSTS[type]), DURATION)
    if (onClose) onClose()
  }

  useEffect(() => {
    setVisible(true)
  }, [])

  return (
    <>
      <div
        style={{
          transform: visible ? 'translateY(0)' : 'translateY(100%)',
          transition: `${DURATION}ms cubic-bezier(0.16, 1, 0.3, 1)`,
        }}
        className={cn(
          'flex flex-col w-full h-full max-full max-h-[calc(100dvh_-36px)] fixed bg-white rounded-t-xl z-30 bottom-0 m-0 left-0',
          className
        )}
      >
        {children}
        <button
          className="text-white absolute flex items-start -top-2 -translate-y-full right-2  font-normal hover:opacity-70 transition-opacity"
          type="button"
          onClick={closeModal}
        >
          <Clear fontSize="small" />
        </button>
      </div>
      <div
        style={{
          transition: `transform ${DURATION}ms, opacity ${DURATION}ms`,
        }}
        className={cn(
          `fixed w-screen h-screen  z-20 bg-black/80`,
          visible ? 'opacity-100' : 'opacity-0',
          overlayClassName
        )}
        onClick={closeModal}
      />
    </>
  )
}
